import axios from 'axios';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

// Salvar carrinho abandonado
export const saveAbandonedCart = async (cartData, token) => {
    const response = await axios.post(
        `${API_URL}/api/abandoned-cart`,
        cartData,
        {
            headers: token ? {
                Authorization: `Bearer ${token}`
            } : {}
        }
    );
    return response.data;
};

// Recuperar carrinho
export const recoverCart = async (token) => {
    const response = await axios.get(
        `${API_URL}/api/abandoned-cart/recover/${token}`
    );
    return response.data;
};

// Marcar como recuperado
export const markCartAsRecovered = async (token, orderId) => {
    const response = await axios.post(
        `${API_URL}/api/abandoned-cart/recover/${token}`,
        { orderId }
    );
    return response.data;
};

